import UsersManagementPage from "./UsersManagementPage";

export default UsersManagementPage;
